export default {
  section: {
    annualTaxes: 'Vos impositions annuelles',
    deductibleCaps: 'Plafonds déductibles',
  },
  label: {
    taxDataIncomeTax: 'Impôt sur le revenu (IR)',
    taxDataSocialSecurityTax: 'Prélèvements sociaux',
    taxDataCehr: 'CEHR',
    taxDataWealthTax: 'Impôt sur la fortune immobilière (IFI)',
    taxDataTotalAnnualTaxes: 'Total de vos impositions annuelles',
    taxDataTaxPressure: 'Pression fiscale',
    taxCeilingUsedAmount: 'Utilisation des plafonds',
    taxCeilingUsedAmountTooltip:
      "Montant du plafonnement des avantages fiscaux déjà utilisé par les dépenses et investissements donnant droit à réductions et crédits d'impôt réalisés pour l'exercice en cours.",
    retirementSavingsRemainingCap: 'Plafond épargne retraite disponible',
    retirementSavingsRemainingCapTooltip:
      "Le montant pouvant être déduit du revenu imposable de l'année en cours en prenant en compte les versements déjà effectués de l'année en cours.",
  },
}
